import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Button, Input} from "antd";

const productsSoldByMonthUrl = `${process.env.PUBLIC_URL}/api/v1/product/productsSoldPerMonth`;

function calculateMonths(fromMonth, toMonth) {
  const months = [];
  const startYear = Number(fromMonth.slice(0, 4));
  const startMonth = Number(fromMonth.slice(5, 7));
  const endYear = Number(toMonth.slice(0, 4));
  const endMonth = Number(toMonth.slice(5, 7));
  if (startYear === endYear) {
    for (let month = startMonth; month <= endMonth; month++) {
      months.push(`${startYear}-${month < 10 ? '0': ''}${month}`);
    }
  } else {
    for (let month = startMonth; month <= 12; month++) {
      months.push(`${startYear}-${month < 10 ? '0': ''}${month}`);
    }
    for (let year = startYear + 1; year <= endYear - 1; year++) {
      for (let month = 0; month <= 12; month++) {
        months.push(`${year}-${month < 10 ? '0': ''}${month}`);
      }
    }
    for (let month = 1; month <= endMonth; month++) {
      months.push(`${endYear}-${month < 10 ? '0': ''}${month}`);
    }
  }
  return months;
}

class ProductsSoldByMonthReport extends React.Component {
  static propTypes = {
    salonId: PropTypes.string.isRequired,
    token: PropTypes.string,
  };

  state = {
    fromMonth: '',
    toMonth: '',
    months: [],
    products: [],
  };

  componentDidMount() {
    this._load().catch(console.error);
  }

  async _load() {
    const {token, salonId} = this.props;
    if (!token || !salonId) return;
    const headers = { "Authorization": "Bearer " + token.access_token };
    const res = await fetch(`${productsSoldByMonthUrl}?salonId=${salonId}`, { headers });
    const data = await res.json();
    const products = Object.entries(data.products).sort(([,{name: a}], [,{name: b}]) => {
      if (a > b) return 1;
      if (a < b) return -1;
      return 0;
    });
    const fromMonth = data.minMonth, toMonth = data.maxMonth;
    const months = calculateMonths(fromMonth, toMonth);
    this.setState({products, months, fromMonth, toMonth});
  }

  _onFromMonthChange = (e) => {
    const value = e.target.value;
    let months = this.state.months;
    if (value.length === 7) {
      months = calculateMonths(value, this.state.toMonth);
    }
    this.setState({ fromMonth: value, months });
  }

  _onToMonthChange = (e) => {
    const value = e.target.value;
    let months = this.state.months;
    if (value.length === 7) {
      months = calculateMonths(this.state.fromMonth, value);
    }
    this.setState({ toMonth: value, months });
  }

  render() {
    return (
      <div style={{maxWidth: "100%", overflowX: "auto"}}>
        {"From "}
        <Input
          style={{width: "100px"}}
          type="text"
          maxLength={7}
          value={this.state.fromMonth}
          onChange={this._onFromMonthChange}
        />
        {" To "}
        <Input
          style={{width: "100px"}}
          type="text"
          maxLength={7}
          value={this.state.toMonth}
          onChange={this._onToMonthChange}
        />
        {" "}
        <Button icon="printer" onClick={() => window.print()}>Print</Button>
        <table>
          <thead>
            <tr>
              <th>Product Name</th>
              {this.state.months.map(month => <th key={month}>{month.slice(2)}</th>)}
            </tr>
          </thead>
          <tbody>
            {this.state.products.map(([productId, {name, byMonth}]) => (
              <tr key={productId} style={{borderBottom: "1px black dashed"}}>
                <td style={{whiteSpace: "nowrap"}}>{name}</td>
                {this.state.months.map(month => (
                  <td key={month} align="right">{byMonth[month] || 0}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
  token: state.auth.token,
});

export default connect(mapStateToProps)(ProductsSoldByMonthReport);



// WEBPACK FOOTER //
// ./src/Product/ProductsSoldByMonthReport.js